import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TimeoutService {
  private timeoutId: any;
  private timeoutDuration: number = 5 * 60 * 1000; // Valor por defecto: 5 minutos
  private timeLeftSubject = new BehaviorSubject<number>(this.timeoutDuration);
  public timeLeft$ = this.timeLeftSubject.asObservable();
  private countdownSubscription: Subscription;

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.fetchTimeoutDuration();
  }

  private fetchTimeoutDuration() {
    const url = `${environment.URL_SERVICE}SolicitudAfiWeb/timeOut`;
    this.http.get<number>(url).subscribe(
      (duration) => {
        this.timeoutDuration = duration * 60 * 1000; // Convertir minutos a milisegundos
        this.timeLeftSubject.next(this.timeoutDuration);
      },
      (error) => {
        console.error('Error fetching timeout duration:', error);
      }
    );
    // this.timeoutDuration = 2 * 60 * 1000; // Convertir minutos a milisegundos
    //     this.timeLeftSubject.next(this.timeoutDuration);
  }

  startTimeout() {
    this.clearExistingTimeout();
    this.setNewTimeout();
    this.startTimeLeftCounter();
  }

  resetTimeout() {
    this.clearExistingTimeout();
    this.setNewTimeout();
    this.resetTimeLeftCounter();
  }

  private clearExistingTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  private setNewTimeout() {
    this.timeoutId = setTimeout(() => {
      this.logout();
    }, this.timeoutDuration);
  }

  private startTimeLeftCounter() {
    this.resetTimeLeftCounter();
  }

  private resetTimeLeftCounter() {
    this.timeLeftSubject.next(this.timeoutDuration);
    this.countdownSubscription = interval(1000).pipe(
      take(this.timeoutDuration / 1000)
    ).subscribe(() => {
      const newTimeLeft = this.timeLeftSubject.value - 1000;
      this.timeLeftSubject.next(newTimeLeft);
      console.log(`Tiempo restante: ${newTimeLeft / 1000} segundos`);
    });
  }

  private logout() {
    this.stopTimeout();
    localStorage.removeItem('sesionAsociado');
    localStorage.removeItem('user');
    sessionStorage.clear(); // Limpia también sessionStorage si es necesario
    alert('Su sesión ha sido cerrada por inactividad.');
    
    // Redirige al usuario a la página de login
    this.router.navigate(['/login']).then(() => {
      // Forzar un refresco de la página después de la redirección
      window.location.reload();
    });
  }

  stopTimeout() {
    this.clearExistingTimeout();
    this.timeLeftSubject.next(0);
  }

}